import { useMemo, useState } from "react";

import Drawer from "../../../components/Drawer/Drawer";
import { splitJobsByStatus } from "../../../handlers/jobStatus";
import JobListingItem, { JobListingItemJob } from "../../JobsPage/components/JobListingItem";
import ViewJob from "../../StaticPages/HomePage/components/ViewJob";

type CompanyJob = JobListingItemJob & {
	jobStatus?: string;
};

interface CompanyJobsProps {
	jobs: CompanyJob[];
	logo?: string;
}

function CompanyJobs({ jobs, logo }: CompanyJobsProps) {
	const [showJobDetailsModal, setShowJobDetailsModal] = useState(false);
	const [selectedJob, setSelectedJob] = useState(null);

	const { openJobs, closedJobs } = useMemo(() => splitJobsByStatus(jobs ?? []), [jobs]);

	const viewJob = (job: CompanyJob) => {
		setSelectedJob(job);
		setShowJobDetailsModal(true);
	};

	return (
		<>
			<Drawer
				isOpen={showJobDetailsModal}
				onClose={() => {
					setShowJobDetailsModal(false);
				}}
			>
				<ViewJob data={selectedJob} setData={setSelectedJob} setShowJobDetailsModal={setShowJobDetailsModal} />
			</Drawer>
			<div className="mt-4">
				<div className="pt-6">
					<h2 className="text-2xl font-semibold mb-4 font-plus-jakarta">
						{openJobs.length === 0 ? "No Open Positions Available" : "Open Positions"}
					</h2>
					<div className="">
						{openJobs.map((job) => (
							<JobListingItem
								key={job._id}
								job={{
									...job,
									logo: logo,
								}}
								showCompany={false}
								onClick={() => viewJob(job)}
								onApply={() => viewJob(job)}
								titleClassName="text-sm font-semibold"
							/>
						))}
					</div>
				</div>

				{closedJobs.length > 0 && (
					<div className="pt-6">
						<h2 className="text-2xl font-semibold mb-1 font-plus-jakarta">Recently Closed</h2>
						<p className="text-sm text-gray-600 mb-4">These roles are no longer accepting applications.</p>
						<div className="">
							{closedJobs.map((job) => (
								<JobListingItem
									key={job._id}
									job={{
										...job,
										logo: logo,
									}}
									showCompany={false}
									onClick={() => viewJob(job)}
									onApply={() => viewJob(job)}
									titleClassName="text-sm font-semibold"
									// Closed roles are read-only: no saving, just the job details.
									hideSaveButton
									ctaLabel="View"
									ctaVariant="secondary"
									statusBadge="Closed"
								/>
							))}
						</div>
					</div>
				)}
			</div>
		</>
	);
}

export default CompanyJobs;
